import { PublicationSearchClaimable } from '../Publication/PublicationSearchClaimable';

export function TranslationSearchClaimable() {
  return <PublicationSearchClaimable />;
}
